import { useMutation } from '@tanstack/react-query'

import { saveSamlRedirectUrl } from '@src/api'
import { DefaultApiSaveSamlRedirectUrlRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useSaveSamlRedirectUrl = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiSaveSamlRedirectUrlRequest) =>
      saveSamlRedirectUrl(axiosInstance, params),
  })
}
